<template>
  <div>
      <div>上一页</div>
  </div>
</template>

<script>
export default {
name:'mePagination'
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/mePagination.vue